import * as React from "react";
const Thumbnails = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Zm14 1v7H5V5h14ZM5 15a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5Zm5 1v3H5v-3h5Zm3 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3Zm1 0v3h5v-3h-5Z" }));
Thumbnails.displayName = "Thumbnails";
var Thumbnails_default = Thumbnails;
export {
  Thumbnails_default as default
};
